import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { CONSUMER_TYPE, CONSUMERS, ConsumerType } from '../domain/consumer-type.domain';
import { LinkRegistryService } from './link-registry.service';

// To match the backend definition and use it at the url
enum SITES {
  WB = 'wb',
  ET = 'et'
}

@Injectable({
  providedIn: 'root'
})
export class WiscService {
  private readonly http = inject(HttpClient);
  private readonly linkRegistryService = inject(LinkRegistryService);
  private readonly locale = inject(LOCALE_ID);
  private readonly consumer = inject<ConsumerType>(CONSUMER_TYPE);

  private readonly cachedData: Record<string, Observable<unknown>> = {};

  getJsonData<Type>(name: string): Observable<Type> {
    const linkBase = this.linkRegistryService.getLink('link_json_base');
    const site = this.isWebbroker() ? SITES.WB : SITES.ET;
    const path = `${linkBase}/${site}/json/${this.locale}/${name}.json`;
    if (!this.cachedData[path]) {
      this.cachedData[path] = this.http.get<Type>(path).pipe(shareReplay(1));
    }
    return this.cachedData[path] as Observable<Type>;
  }

  private isWebbroker(): boolean {
    return this.consumer.consumerId === CONSUMERS.CONSUMER_ID_WEB_BROKER;
  }
}

